module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r1n4r8r-495c7a5a653b60a232c53085eee63703.svg";